module.exports = __webpack_public_path__ + "img/electricity-outlets.e488d64a.svg";